module.exports = __webpack_public_path__ + "static/dance-7357be52842912517c8a8c447a99a5e6.svg";